import { z } from "zod";

import { rotationStringValues } from "@/utils/rotation-utils";

import { packagingComponentBaseSavedSchema } from "./packaging-component-base-saved";
import { contentSavedSchema } from "./content-saved";
import { packagingComponentLabelSavedSchema } from "./packaging-component-label-saved";
import { packagingComponentPrintSavedSchema } from "./packaging-component-print-saved";
import { cartonClosingSchema } from "./carton-closing";

export const packagingComponentCartonSavedSchema = packagingComponentBaseSavedSchema.extend({
	rotation: z.enum(rotationStringValues).nullable().optional(),
	// TODO original is	contents: z.array(contentSavedSchema),
	contents: z.array(contentSavedSchema).optional(),
	labels: z.array(packagingComponentLabelSavedSchema),
	prints: z.array(packagingComponentPrintSavedSchema).optional(),
	closing: cartonClosingSchema.nullable().optional(),
});

export type PackagingComponentCartonSaved = z.infer<typeof packagingComponentCartonSavedSchema>;
